import React from "react";
import logo from "../../../img/Home/BLUECORNER_PNG.png";
import background from "../../../img/Comprobar_disponibilidad.png";
import { Link } from "react-router-dom";
import colores from "../../helpers/colores";

const ComprobarDisponibilidadPaquetes = () => {
    return (
        <div className="flex">
            <div
                style={{
                    backgroundImage: `url(${background})`,
                    filter: "brightness( 100% ) contrast( 113% ) saturate( 100% ) blur( 0px ) hue-rotate( 0deg )",
                }}
                className={`w-full bg-[${colores.primario}] h-screen bg-center bg-no-repeat
                bg-cover flex flex-col text-center`}>
                <div className="h-screen bg-[rgba(5,52,101,0.60)]">
                    <div className="w-full">
                        <img
                            src={logo}
                            className="mt-20 lg:h-36 min-h-[3rem] w-full lg:max-w-md"
                        />
                    </div>
                    <h1 className="p-4 mt-20 text-4xl font-bold text-white lg:text-5xl">
                        Muchas gracias por tu pedido, estamos comprobando la
                        disponibilidad.
                    </h1>
                    <h1 className="mt-5 text-xl font-bold text-white lg:text-3xl">
                        Nos contactaremos contigo lo antes posible.
                    </h1>
                    <div className="px-10">
                        <div className="flex flex-col max-w-lg py-10 mx-auto mt-10 rounded-lg bg-neutral-200 lg:mt-28 opacity-95">
                            <h1 className="px-10 py-2 mb-10 text-2xl text-gray-600">
                                Mientras esperas, puedes ver algunos de nuestros
                                alojamientos.
                            </h1>
                            <Link to="/">
                                <span
                                    className={`font-semibold hover:border hover:underline border-gray-400 bg-[${colores.secundario}] text-white p-3 min-w-max mx-auto cursor-pointer rounded-md text-lg`}>
                                    Volver
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComprobarDisponibilidadPaquetes;
